export const GET_SALES_SITES = "GET_SALES_SITES";
export const GET_COMMERTIAL_LEAD_DETAILS = "GET_COMMERTIAL_LEAD_DETAILS";
export const GET_SALES_INCENTIVE = "GET_SALES_INCENTIVE";
export const GET_BENEFICIARY_SENIOR = "GET_BENEFICIARY_SENIOR";
export const GET_INCENTIVE_DATA = "GET_INCENTIVE_DATA";
export const GET_FINANCE_INCENTIVE_LIST =  "GET_FINANCE_INCENTIVE_LIST";
export const ACCEPT = "ACCEPT";
export const REJECT = "REJECT";
export const GET_USER_SENIOR_INCENTIVES = "GET_USER_SENIOR_INCENTIVES";
export const UPLOAD_UTR = "UPLOAD_UTR";